import React from 'react';

import Logo from '../Components/Logo';

import styles from '../styles/UnavailableSystem.module.css';

const UnavailableSystem = ({ dbStatus }) => {
  return (
    <span className={styles.lining}>
        <div className={styles.card}>
            <div className={styles.unLogo}><Logo to='/' position='relative' /></div>
            <a className={styles.bigText}>Система в данный момент недоступна.</a>
            <a className={styles.explanation}>Попробуйте обновить страницу позже. Если вы используете VPN, рекомендуем отключить его.<br/>Статус: {dbStatus}</a>
        </div>
    </span>
  )
}

export default UnavailableSystem;